<div class="container">
    <div class="header">
        <div class="header-image">
            <img tid="intralink" src="./assets/images/intralinks_logo.png" class="img-intralink" alt="intralink">
        </div>
        <!-- https://maintenance-apiclienttest.intralinks.com/login/resources/images/iam-logo.png -->
        <div class="header-text h1-light">{{name}}</div>
        <!-- <button tam-button tamType="primary" class="header-button" tamSize="normal" (click)="editAccount()">
            <smart-icon name="cog" size="16"></smart-icon>&nbsp;Configure
        </button> -->

        <smart-icon *ngIf="screenDeletable && screenEditable"name="meatball" class="intralink-action" (click)="showContextMenu($event)"></smart-icon>
    </div>
    <div class="body" loading-spin [isLoading]="loading.tree" [loadingSize]="'normal'">
        <div class="body-tree">
            <div *ngIf="treeListOptions && treeListOptions.items && treeListOptions.items.length > 0">
                <aacl-tree-list [options]="treeListOptions"></aacl-tree-list>
            </div>
            <div *ngIf="!treeListOptions" class="no-data">
                No Workspace Found
            </div>
        </div>
        <div class="body-content" [hidden]="loading.tree">
            <tam-intralinks-content-container [config]="contentContainerConfig"></tam-intralinks-content-container>
        </div>
        <!-- <div class="body-content" *ngIf="!timeFilter">
            <tam-intralinks-folder [files]="files" [loading]="loading.content"></tam-intralinks-folder>
        </div>
        <div class="body-content" *ngIf="timeFilter" loading-spin [isLoading]="loading.content" [loadingSize]="'normal'">
            <tam-intralinks-group-container [config]="groupConfig">
            </tam-intralinks-group-container>
        </div> -->
    </div>
</div>
<tam-context-menu tid="intralinks-account-meatball" [config]="contextMenuConfig"></tam-context-menu>
<tam-intralinks-validation></tam-intralinks-validation>